import AppTSX from "./App.tsx";
export default AppTSX;